(function () {
  function initOurStory() {
    var forms = document.querySelectorAll('[data-os-newsletter]');
    forms.forEach(function (form) {
      if (form.dataset.osBound === '1') return;
      form.dataset.osBound = '1';
      form.addEventListener('submit', function () {
        var msg = form.querySelector('[data-os-newsletter-msg]');
        if (msg) msg.hidden = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOurStory);
  } else {
    initOurStory();
  }

  document.addEventListener('shopify:section:load', initOurStory);
})();
